export default {
    Names: {
        AGPool: 'AGPool',
        AGDToken: 'AGDToken',
        AGSToken: 'AGSToken',
        VaultWallet: 'VaultWallet',
        TeamWallet: 'TeamWallet',
        StakePool: 'AGStakePool',
        StakeStorage: 'AGStakeStorage',
        StakeTick: 'StakeTick',
        StakeVaultPool: 'StakeVaultPool',
        LoanPool: 'AGLoanPool',
        LoanStorage: 'AGLoanStorage',
        LoanTick: 'LoanTick',
        LoanVaultPool: 'LoanVaultPool',
        SwapRouter: 'SwapRouter',
        ContractRegistry: 'ContractRegistry',
        SwapFactory: 'SwapFactory',
        AppTicket: 'AppTicket',
        TokenRechargePool: 'TokenRechargePool',
        TokenManager: 'TokenManager',
    },
    Registries: {
        AGPool: 'AGPOOL',
        AGDToken: 'AGDTOKEN',
        AGSToken: 'AGSTOKEN',
        VaultWallet: 'VAULT_WALLET',
        TeamWallet: 'TEAM_WALLET',
        StakePool: 'STAKE_POOL',
        StakeStorage: 'STAKE_STORAGE',
        StakeTick: 'STAKE_TICK',
        StakeVaultPool: 'STAKE_POOL_VAULT',
        LoanPool: 'LOAN_POOL',
        LoanStorage: 'LOAN_STORAGE',
        LoanTick: 'LOAN_TICK',
        PoolPaymentToken: 'POOL_PAYABLE',
    },
};
